export const ReportSubmited = () => {
  return (
    <div className="hero min-h-screen bg-base-200">
      <div className="hero-content flex-col lg:flex-row">
        <img
          alt="livre"
          src="/image/thumb-up.png"
          className=" w-1/2 lg:max-w-sm rounded-lg shadow-2xl"
        />
        <div>
          <h1 className=" text-md lg:text-5xl font-bold">Formulaire envoyé</h1>
          <p className="py-6">
            Nous vous contacterons par téléphone ou par mail pour vous avertir
            du rapport dans un délai maximum de 5 jours.
          </p>
        </div>
      </div>
    </div>
  );
};
